/// <reference path="../../../typings/browser.d.ts" />
namespace Application.Controllers {
    'use strict';

    import ICloseParameters = ngModal.ICloseParameters;

    export interface IJsonModalScope extends ng.IScope {
        formData: any;
        fields: any[];
        json: string
        loadJson: () => void;
        modalClose: () => void;
        modalSave: () => void;
        getLabel:(id:string,fields:any[])=>string;
    
    }


    export class JsonModalController {
        public static templateURL: string = "decorators/modals/json-modal.html";
        private close: (parameters: ngModal.ICloseParameters) => void;
        public static ID: string = "#id-json-modal";
        public static $name: string = "jsonModalController";
        static $inject = ['$scope', 'jsonService', 'data','close'];
        private $scope: IJsonModalScope;

        constructor($scope: IJsonModalScope, private jsonService: Services.JsonService, private data: any,close: (parameters: ngModal.ICloseParameters) => void) {
            this.$scope = $scope;
            this.close=close
            $scope.formData = data;
            /* $scope.formData = { takerName: 'QWERTY', takerCore: 'C2', protocol: 'RTP', srtServer: 'FR5A2', srtCoreNumber: 'C09', 
                numberOfServices: 3, 
                servicesStartingNumber: 'S341', 
                firstMulticastOfTheRange: '239.20.10.11', firstSrtPortOfTheRange: 48210, 
                srtServerMgtIp: '10.73.89.40', srtServerIntIp: '10.73.89.182', srtServerExtIp: '10.73.89.181'} */
            $scope.fields = [
                { id: 'takerName', label: 'TAKER NAME', model: 'takerName' },
                { id: 'takerCore', label: 'TAKER CORE (C1,C2...)', model: 'takerCore' },
                { id: 'protocol', label: 'PROTOCOL (UDP,RTP)', model: 'protocol' },
                { id: 'srtServer', label: 'SRT SERVER (FR5A1,FR5A2,...)', model: 'srtServer' },
                { id: 'srtCoreNumber', label: 'SRT CORE NUMBER (C06,C07,...)', model: 'srtCoreNumber' },
                { id: 'numberOfServices', label: 'NUMBER OF SERVICES (6,10,...)', model: 'numberOfServices' },
                { id: 'servicesStartingNumber', label: 'SERVICES STARTING NUMBER (S121)', model: 'servicesStartingNumber' },
                { id: 'firstMulticastOfTheRange', label: 'FIRST MULTICAST OF THE RANGE (239.1.1.11)', model: 'firstMulticastOfTheRange' },
                { id: 'firstSrtPortOfTheRange', label: 'FIRST SRT PORT OF THE RANGE', model: 'firstSrtPortOfTheRange' },
                { id: 'srtServerMgtIp', label: 'SRT SERVER MGT IP', model: 'srtServerMgtIp' },
                { id: 'srtServerIntIp', label: 'SRT SERVER INT IP', model: 'srtServerIntIp' },
                { id: 'srtServerExtIp', label: 'SRT SERVER EXT IP', model: 'srtServerExtIp' }
            ];

            
            $scope.loadJson = () => {
                this.jsonService.readJson($scope.json).then((data: any) => {
                    $scope.formData = data;
                }, (error: any) => {
                    console.error('Error:', error);
                });
            };

            this.$scope.modalSave = (): void => {
                this.jsonService.generateInformation($scope.formData);
                this.close(undefined)

            }; 
            
            $scope.getLabel= (id: string, fields:any[]): string =>{
                return fields.filter((field)=>field.id===id)[0].label
            }

        }

        
    }

}